<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-product-unregulated-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-product-unregulated-create>

<pg-product-unregulated-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-product-unregulated-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
